import { actions }  from "./mainActions";
import dotProp from "dot-prop-immutable";

export default function reducer(state={}, action) {
    const payload = action.payload;
    switch (action.type) {
        default:
            break;
    }

    return state;
}